import { HowItWorksSection } from "../components/Home/HowItWorks";
import { HeroSection } from "../components/Home/Hero";
import { FeaturedItemsSection } from "../components/Home/Featured";

export default function Home() {
  return (
    <div>
      <HeroSection />
      <FeaturedItemsSection />
      <HowItWorksSection />
    </div>
  );
}
